var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('flixDashboard',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"flix-container"},[_c('flixCheckPermissions',{attrs:{"role":"profile","permission":"3","error":""}},[_c('permissions')],1)],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }